"use strict";

exports.__esModule = true;
exports.numericRenderer = exports.RENDERER_TYPE = void 0;
var _numericRenderer = require("./numericRenderer");
exports.RENDERER_TYPE = _numericRenderer.RENDERER_TYPE;
exports.numericRenderer = _numericRenderer.numericRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/numericRenderer/index.js
// module id = 573
// module chunks = 0